import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Portal } from '@/components/functional/portal/Portal';
import { Card } from '@/components/ui/Surface/Card';
import { Overlay } from '@/components/ui/Surface/Overlay';
export const Modal = (props) => {
    const { children, className = '', hideModal = undefined, isShow, maxWidth = 'max-w-[700px]', selector, } = props;
    return (_jsx(Portal, Object.assign({ selector: selector }, { children: _jsx(Overlay, Object.assign({ className: 'relative z-[1020]', innerClassName: 'flex justify-center items-center', isShow: isShow, onClick: hideModal }, { children: _jsx(Card, Object.assign({ className: clsx(['w-full', maxWidth], 'max-h-[90vh]', 'my-16 mx-16', 'overflow-y-auto', 'relative z-[1]', className), isRounded: true, isShadow: true }, { children: children })) })) })));
};
